import { Component, inject } from '@angular/core';
import { BaseDialogComponent } from '../../../../kit/base-dialog/base-dialog.component';
import { IndividualPlanComponent } from '../individual-plan.component';
import { FolderGlobalStore } from '../../../../../store/medicalService/folder.global-store';
import { routeParams } from '../../../../../modules/shared/shared.global-service';

@Component({
    selector: 'app-individual-plan-dialog',
    templateUrl: './individual-plan-dialog.component.html',
    styleUrl: './individual-plan-dialog.component.scss',
    imports: [
        IndividualPlanComponent,
    ],
    providers: [
        FolderGlobalStore,
    ],
})
export class IndividualPlanDialogComponent extends BaseDialogComponent {

    private readonly folderStore = inject(FolderGlobalStore);

    constructor() {
        super();
        this.folderStore.setFolderId(routeParams.folderId());
        this.folderStore.setDialogComponent(this);
    }

}
